import { motion } from "framer-motion"

export const MotionDiv = motion.div
export const MotionSpan = motion.span